"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledAdornedInput = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _AdornedInputMixin = require("../../mixins/components/AdornedInputMixin");
var _doNotForwardTransientProp = require("../../util/doNotForwardTransientProp");
var StyledAdornedInput = /*#__PURE__*/(0, _styledComponents.default)('div').withConfig({
  shouldForwardProp: (0, _doNotForwardTransientProp.doNotForwardTransientProp)(['disabled', 'readOnly'])
}).withConfig({
  displayName: "StyledAdornedInput",
  componentId: "c11n-8-107-0__sc-tbqtlr-0"
})(["", ""], _AdornedInputMixin.AdornedInputMixin);
exports.StyledAdornedInput = StyledAdornedInput;